export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b-2 border-orange-400 inline-block pb-1">
              Services
            </h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Estimating
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  BIM Modeling
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  P6 Scheduling
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  MS Project
                </button>
              </li>
            </ul>
          </div>

          {/* Industries */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b-2 border-orange-400 inline-block pb-1">
              Industries
            </h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Commercial
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Infrastructure
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Industrial
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Energy
                </button>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b-2 border-orange-400 inline-block pb-1">
              Company
            </h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Case Studies
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Careers
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-white/90 hover:text-white transition-colors text-sm whitespace-nowrap">
                  Blog
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 border-b-2 border-orange-400 inline-block pb-1">
              Contact
            </h3>
            <ul className="space-y-3">
              <li className="text-white/90 text-sm">
                <i className="ri-mail-line mr-2"></i>
                admin@civconllc.com
              </li>
              <li className="text-white/90 text-sm">
                <i className="ri-phone-line mr-2"></i>
                +1 (941) 565-5955
              </li>
              <li className="text-white/90 text-sm">
                <i className="ri-map-pin-line mr-2"></i>
                One World Trade Center
              </li>
              <li className="text-white/90 text-sm">
                New York, NYC 10007
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
            {/* Company Name */}
            <div>
              <div className="flex items-center gap-3 mb-2">
                <img 
                  src="https://public.readdy.ai/ai/img_res/5480a3d1-d7d6-427f-b2bf-f97f490ba9e8.png" 
                  alt="Company Logo" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-white/80 text-sm">
                Precision Consulting for Mega Projects
              </p>
            </div>

            {/* Social & Copyright */}
            <div className="text-center lg:text-right">
              <div className="flex gap-3 justify-center lg:justify-end mb-3">
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-orange-600 rounded-full hover:bg-orange-700 transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-orange-600 rounded-full hover:bg-orange-700 transition-colors cursor-pointer"
                >
                  <i className="ri-twitter-x-fill text-lg"></i>
                </a>
              </div>
              <p className="text-white/70 text-sm">
                © 2024 Construction Consulting. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}